import type { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import RoundedArrowButton from '@components/RoundedArrowButton/RoundedArrowButton';

import { NavigationButtonWrapper } from './DateNavigator.style';

/**
 * VITALL-styled navigation arrow button component for the routine scheduler toolbar
 */
const NavigationButton = ({
  ...props
}: DateNavigator.NavigationButtonProps) => {
  const { type, onClick } = props;
  const { palette } = useTheme();
  return (
    <NavigationButtonWrapper>
      <RoundedArrowButton
        color={palette.primary.light}
        onClick={() => {
          if (onClick) {
            onClick(null);
          }
        }}
        rotation={type === 'forward' ? -90 : 90}
      />
    </NavigationButtonWrapper>
  );
};

export default NavigationButton;
